import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { universitiesAPI } from '@/lib/api';

const PartnersLogos = () => {
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        const response = await universitiesAPI.getAll();
        setUniversities(response.data);
      } catch (error) {
        console.error('Failed to fetch universities:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchUniversities();
  }, []);

  if (loading || universities.length === 0) {
    return null;
  }

  // Duplicate logos for smooth infinite scroll
  const timesToDuplicate = universities.length < 5 ? 6 : 3;
  const duplicatedLogos = Array(timesToDuplicate).fill(universities).flat();

  return (
    <section className="py-16 bg-gradient-to-b from-black to-[#0a0a0a] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl font-light text-white mb-3">
            دانشگاه‌های <span className="text-[#D4AF37]">معتبر</span> ما
          </h2>
          <p className="text-zinc-400 text-sm">
            همکاری با معتبرترین دانشگاه‌ها و نهادهای بین‌المللی
          </p>
        </div>
      </div>

      {/* Infinite Scrolling Logos */}
      <div 
        className="relative group/container"
        onMouseEnter={(e) => {
          const scrollDiv = e.currentTarget.querySelector('[data-scroll]');
          if (scrollDiv) scrollDiv.style.animationPlayState = 'paused';
        }}
        onMouseLeave={(e) => {
          const scrollDiv = e.currentTarget.querySelector('[data-scroll]');
          if (scrollDiv) scrollDiv.style.animationPlayState = 'running';
        }}
      >
        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none"></div>

        {/* Scrolling Container */}
        <div 
          data-scroll
          className="flex gap-12"
          style={{
            width: 'max-content',
            animation: 'scroll 40s linear infinite'
          }}
        >
          {duplicatedLogos.map((university, index) => (
            <Link
              key={`${university.id}-${index}`}
              to={`/universities/${university.id}`}
              className="flex-shrink-0 group relative"
            >
              <div className="w-32 h-32 flex items-center justify-center p-4 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-300 hover:scale-110 hover:bg-white/10 cursor-pointer">
                <img
                  src={university.logo_url}
                  alt={university.name_fa}
                  className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                  loading="lazy"
                  onError={(e) => {
                    // Fallback to placeholder if logo fails to load
                    e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><rect fill="%23D4AF37" width="100" height="100" rx="10"/><text x="50" y="55" font-size="40" fill="white" text-anchor="middle" font-family="Arial">' + university.name_fa.charAt(0) + '</text></svg>';
                  }}
                />
              </div>
              
              {/* Tooltip on hover */}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-20">
                <div className="bg-gradient-to-r from-[#1a1a1a] to-[#2a2a2a] border border-[#D4AF37]/50 rounded-lg px-4 py-2 shadow-xl whitespace-nowrap">
                  <p className="text-[#D4AF37] text-sm font-medium">{university.name_fa}</p>
                  {university.rank && (
                    <p className="text-zinc-400 text-xs mt-1">رتبه: {university.rank}</p>
                  )}
                </div>
                <div className="w-3 h-3 bg-[#1a1a1a] border-r border-b border-[#D4AF37]/50 absolute -bottom-1 left-1/2 -translate-x-1/2 rotate-45"></div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-100% / ${timesToDuplicate}));
          }
        }
      `}</style>
    </section>
  );
};

export default PartnersLogos;
